<template lang="pug">
  app-page.gsu-module(title="Главное следственное управление" )
    statToolbar

    v-simple-table( light )
      template( v-slot:default )
        thead
          tr
            th( class="text-center") Номер по порядку     
            th Период               
            th Подразделение        
            th( class="text-center") Категория (Суд)      
            th( class="text-center") Категория (МИВС, ИВС)
        tbody
          tr( v-for="item, index in statSort" )
            td( class="text-center") {{index + 1}}
            td {{$_shortFormatRu(statperiod.start)}} - {{$_shortFormatRu(statperiod.end)}}
            td {{item.subdivision}}
            td( class="text-center") {{item.court}}
            td( class="text-center") {{item.other}}

          tr
            td( class="text-center") Итого
            td {{$_shortFormatRu(statperiod.start)}} - {{$_shortFormatRu(statperiod.end)}}
            td 
            td( class="text-center") {{stat.reduce((sum, i) => sum + i.court, 0)}}
            td( class="text-center") {{stat.reduce((sum, i) => sum + i.other, 0)}}


</template>

<script>
import { mapState } from 'vuex';
import statToolbar from './components/StatToolbar'
import { $_app_moment } from "@/common/AppMoment.js"

export default {
  mixins: [ $_app_moment ],
  components: {
    statToolbar,
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapState('gsu', [ 'stat' ,'statperiod' ]),
    statSort() {
      let res = this.stat
      return res.sort((a, b) => a.subdivision.localeCompare(b.subdivision))
    }
  },

  methods: {
  },

  created() {
    this.$store.dispatch('gsu/LOAD_STAT')
  },

}


</script>

<style lang="scss" scoped>
.ellipse {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 6px;

  &[data-color="red"] {
    background: #ED0E51;
  }
  &[data-color="yellow"] {
    background: #F2BE38;
  }
  &[data-color="green"] {
    background: #2BC113;
  }
}
</style>

<style lang="scss">
.gsu-module {
 .document {
   display: flex;
   flex-flow: row wrap;
   margin-left: -14px;
   margin-right: -14px;
   >div {
     width: 33.3333333333%;
     background-color: transparent;
     padding-left: 14px;
     padding-right: 14px;
     margin-bottom: 14px;
   }
 }
}
</style>
